class ActivateGtm {
    constructor(isFull) {
        if (isFull) {
            this.activateGtm();
        }
    }
    activateGtm() {
        try {
            this.activateAddToCart();
            this.activateRemoveFromCart();
            this.activateRemoveFromAllCart();
            this.activateViewCart();
            this.activateViewDetailProduct();
            this.activateViewListProduct();
            this.activateAddToWishList();
            this.activateSearchProduct();
            this.activateUserLogin();
            this.activateChangeShipping(true);
            this.activateSelectPaymentMethod(true);
            this.activateBeginCheckout();
            this.activatePurchaseCheckout();
            this.activateSelectItemProduct();
        } catch (error) {
            console.log(error);
        }
    }

    activateAddToCart() {
        waitForElm(".gtm-add-to-cart")
            .then(function (elm) {
                activateSelectors(".gtm-add-to-cart", AddToCartEventListener);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    activateRemoveFromCart() {
        waitForElm(".gtm-remove-from-cart")
            .then(function (elm) {
                waitForAngularElement(".gtm-remove-from-cart")
                    .then(function (elm) {
                        activateSelectors(
                            ".gtm-remove-from-cart",
                            RemoveFromCartEventListener
                        );
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    activateRemoveFromAllCart() {
        waitForElm(".gtm-remove-from-allcart")
            .then(function (elm) {
                waitForAngularElement(".gtm-remove-from-allcart")
                    .then(function (elm) {
                        activateSelectors(
                            ".gtm-remove-from-allcart",
                            RemoveFromCartEventListener
                        );
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    activateViewCart() {
        waitForElm(".gtm-view-cart")
            .then(function (elm) {
                var viewCart = new ViewCartEventListener();
                try {
                    viewCart.callback();
                } catch (error) {
                    console.error(error);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    activateViewDetailProduct() {
        waitForElm(".product-detail")
            .then(function (elm) {
                var viewProduct = new ProductViewEventListener(elm);
                try {
                    viewProduct.callback();
                } catch (error) {
                    console.error(error);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    activateSelectItemProduct() {
        waitForElm(".gtm-product-click")
            .then(function (elm) {
                activateSelectors(
                    ".gtm-product-click",
                    ProductSelectItemListener
                );
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    activateViewListProduct() {
        waitForElm(".gtm-product-list")
            .then(function (elm) {
                var viewProduct = new ProductListViewEventListener(elm);
                try {
                    viewProduct.callback();
                } catch (error) {
                    console.error(error);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    activateAddToWishList() {
        waitForElm(".gtm-add-wishlist")
            .then(function (elm) {
                activateSelectors(
                    ".gtm-add-wishlist",
                    AddToWishListEventListener
                );
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    activateSearchProduct() {
        waitForElm(".gtm-search-button")
            .then(function (elm) {
                activateSelectors(
                    ".gtm-search-button",
                    ProductSearchEventListener
                );
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    activateUserLogin() {
        waitForElm(".social-login")
            .then(function (elm) {
                activateSelectors(".social-login", UserLoginEventListener);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    activateChangeShipping(first) {
        waitForElm(".gtm-shipping-info").then(function (elm) {
            waitForAngularElement(".gtm-shipping-info")
                .then(function (elm1) {
                    activateSelectors(
                        ".gtm-shipping-info",
                        SelectShippingEventListener
                    );
                    if (first) {
                        var shipping = new SelectShippingEventListener(elm);
                        try {
                            shipping.callback();
                            shipping.listen();
                        } catch (error) {
                            console.error(error);
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .catch(function (error) {
                    console.log(error);
                });
        });
    }
    activateSelectPaymentMethod(first) {
        waitForElm(".gtm-payment-method")
            .then(function (elm) {
                activateSelectors(
                    ".gtm-payment-method",
                    SelectPaymentMethodEventListener
                );
                if (first) {
                    var payment = new SelectPaymentMethodEventListener(elm);
                    try {
                        payment.callback();
                        payment.listen();
                    } catch (error) {
                        console.error(error);
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    activateBeginCheckout() {
        waitForElm(".gtm-begin-checkout")
            .then(function (elm) {
                activateSelectors(
                    ".gtm-begin-checkout",
                    BeginCheckoutEventListener
                );
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    activatePurchaseCheckout() {
        waitForElm(".gtm-payment-success")
            .then(function (elm) {
                var paymentSuccess = new PurchaseCheckoutEventListener(elm);
                try {
                    paymentSuccess.callback();
                } catch (error) {
                    console.error(error);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    activatePromotionSelection() {
        waitForElm(".gtm-select-promotion")
            .then(function (elm) {
                activateSelectors(
                    ".gtm-select-promotion",
                    SelectPromotionEventListener
                );
            })
            .catch(function (error) {
                console.log(error);
            });
    }
}
